import React, { Component, useState, useRef } from "react";
import { useEffect } from "react";
import {
  MapContainer,
  TileLayer,
  Polygon,
  Marker,
  useMapEvents,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import { Multiselect } from "multiselect-react-dropdown";
import L from "leaflet";
import axios from "axios";
import swal from "sweetalert";
import Baseurl from "../../../Baseurl";
import { useHistory } from "react-router-dom";

var vikki = [];
var Saved = [];
function AddMarkerToClick(props) {
  const [markers, setMarkers] = useState([]);
  const [status, setStatus] = useState(false);

  const [polyChords, setPolyChords] = useState([]);

  const map = useMapEvents({
    click(e) {
      if (!status) {
        setStatus(false);

        vikki.push([e.latlng.lat, e.latlng.lng]);
        Saved.push({ Lat: e.latlng.lat, Lng: e.latlng.lng });
        setPolyChords(vikki);
        const newMarker = e.latlng;
        setMarkers([...markers, newMarker]);
      }
    },
  });

  function createPolyGon() {
    setStatus(true);
  }

  function clearAllMarkers() {
    setMarkers([]);
    setPolyChords([]);
    vikki = [];
    Saved = [];
    setStatus(false);
  }
  function MyButton() {
    const map = useMap();

    const handleClick = () => {
      // Do something when the button is clicked
      clearAllMarkers();
    };

    useEffect(() => {
      const container = L.DomUtil.create(
        "div",
        "leaflet-bar leaflet-control leaflet-control-custom"
      );

      container.innerHTML =
        '<button  class="mapButton" type="button">Clear Polygon</button>';
      container.onclick = handleClick;

      L.DomEvent.disableClickPropagation(container);
      map
        .getContainer()
        .querySelector(".leaflet-bottom.leaflet-left ")
        .appendChild(container);

      return () => {
        // Clean up the button when the component is unmounted
        container.remove();
      };
    }, [map, handleClick]);

    return null;
  }
  return (
    <>
      <MyButton />
      {markers.map((marker, i) => (
        <Marker position={marker}>
          {polyChords.length !== 0 && (
            <>
              {status ? (
                <Polygon positions={polyChords} fillOpacity={0.09} />
              ) : (
                <Polyline positions={polyChords} />
              )}
            </>
          )}

          {i === 0 && (
            <Popup>
              <div style={{ cursor: "pointer", color: "blue" }}>
                {status ? (
                  <div onClick={() => {}}>Create Geofence</div>
                ) : (
                  <>
                    {markers.length <= 2 ? (
                      <div>Points Should be more than 2</div>
                    ) : (
                      <div onClick={createPolyGon}>
                        click here to create polygon
                      </div>
                    )}
                  </>
                )}
              </div>
            </Popup>
          )}
        </Marker>
      ))}
    </>
  );
}

export default function MapPolyLine() {
  const [disableStatus, setDisableStatus] = useState(true);
  const [vehicleData, setVehicleData] = useState([]);
  const [name, setName] = useState("");
  const [catList, setCatList] = useState([]);
  const [serviceCategory, setServiceCategory] = useState("");
  const [existedPolyLine, setExistedPolyLine] = useState([]);
  const history = useHistory();
  const mapRef = useRef(null);
  var moverVehicle = [
    { name: "Bike" },
    { name: "3 Wheeler" },
    { name: "Tata Ace" },
    { name: "PickUp 8ft" },
    { name: "Tata 407" },
  ];
  var foodVehicle = [{ name: "Bike" }, { name: "Auto" }];
  var healthVehicle = [{ name: "Bike" }];
  var taxiVehicle = [
    { name: "Bike" },
    { name: "Auto" },
    { name: "Hatch Back" },
    { name: "Sedan" },
    { name: "SUV/MUV" },
  ];
  var airportVehicle = [
    { name: "Hatch Back" },
    { name: "Sedan" },
    { name: "SUV/MUV" },
  ];
  const selection3 = (selectedValues) => {
    axios
      .get(Baseurl.baseurl + `/health/get-all-geofence`)
      .then((res) => {
        if (res.data.status) {
          let latLngArray = [];
          res.data.data.map((val) => {
            let latLng = [];
            if (val.GeofenceCategory === selectedValues[0].category) {
              val.GeofenceLatLng.map((value) => {
                latLng.push([value.Lat, value.Lng]);
              });
            }
            if (latLng.length !== 0) {
              latLngArray.push({ latlong: latLng, name: val.GeofenceName });
            }
          });
          setExistedPolyLine(latLngArray);
          setDisableStatus(true);
        }
      })
      .catch((err) => {});
    setServiceCategory(selectedValues[0].category);
  };
  useEffect(()=>{
    axios
    .get(Baseurl.baseurl + `/health/get-all-geofence`)
    .then((res) => {
      if (res.data.status) {
        let latLngArray = [];
        res.data.data.map((val) => {
          let latLng = [];
          val.GeofenceLatLng.map((value) => {
            latLng.push([value.Lat, value.Lng]);
          });
          if (latLng.length !== 0) {
            latLngArray.push({ latlong: latLng, name: val.GeofenceName });
          }
        });
        setExistedPolyLine(latLngArray);
        setDisableStatus(true);
      }
    })
    .catch((err) => {});
  },[])
  const selection2 = (selectedValues) => {
    let vig = [];
    selectedValues.map((val) => {
      vig.push(val.name);
    });
    setVehicleData(vig);
  };
  // function getCategory() {
  //   let cat = [];
  //   axios
  //     .get(Baseurl.baseurl + `/go-ui/get-category`)
  //     .then((res) => {
  //       res.data.categories.map((val) => {
  //         cat.push({ category: val.Category, title: val.Category });
  //       });
  //       cat.push({ category: "others", title: "Others" });
  //       setCatList(cat);
  //     })
  //     .catch((err) => {});
  // }
  useEffect(() => {
    // getCategory();
  }, []);
  function createGeofence() {
    let geofenceDetails = {
      geofenceName: name,
      category: "Go_Taxi",
      vehicleType: "Bike",
      geofenceLatLng: Saved,
    };
    axios
      .post(Baseurl.baseurl + `/health/create-geofence`, geofenceDetails)
      .then((res) => {
        if (res.data.status) {
          swal("Created", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          history.push("/All-Polylines");
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
  return (
    <>
      {disableStatus && (
        <div>
          {existedPolyLine.length !== 0 ? (
            <MapContainer
              ref={mapRef}
              style={{
                height: window.innerHeight / 1.6,
                width: window.innerWidth / 1.4,
                position: "fixed",
                top: "210px",
              }}
              scrollWheelZoom={true}
              bounds={existedPolyLine.map((val) => {
                return val.latlong;
              })}
            >
              {existedPolyLine.map((val) => {
                return (
                  <Polygon
                    positions={val.latlong}
                    fillOpacity={0.1}
                    color="red"
                  >
                    <Popup position={val.latlong[0]}>
                      <div>{val.name}</div>
                    </Popup>
                  </Polygon>
                );
              })}

              <AddMarkerToClick />

              <TileLayer
        url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        maxZoom={21}
        minZoom={4}
        minZoomIsDrawing={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
            </MapContainer>
          ) : (
            <MapContainer
              style={{
                height: window.innerHeight / 1.6,
                width: window.innerWidth / 1.4,
                position: "fixed",
                top: "210px",
              }}
              center={[12.93028, 77.676136]}
              zoom={13}
              scrollWheelZoom={true}
            >
              <Polygon positions={existedPolyLine} fillOpacity={0.09} />
              <AddMarkerToClick />

              <TileLayer
        url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
        maxZoom={21}
        minZoom={4}
        minZoomIsDrawing={18}
        subdomains={["mt0", "mt1", "mt2", "mt3"]}
      />
            </MapContainer>
          )}
        </div>
      )}

      <div
        style={{ position: "fixed", top: "130px", zIndex: 10 }}
        className="form-group row"
      >
      

        {disableStatus && (
          <>
            <div className="col-sm-4 map-text">
              <label>
                {" "}
                <strong>Geofence Name</strong>
              </label>
              <input
                value={name}
                type="text"
                style={{borderRadius:'5px',width:"100%"}}
                className="form-control"
                placeholder="enter name"
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            {/* <div className="col-sm-5 map-text">
              <label>
                <strong>Vehicle Name</strong>
              </label>
              <Multiselect
                closeIcon="close"
                options={taxiVehicle}
                displayValue="name"
                onSelect={selection2}
              />
            </div> */}

            <div className="col-sm-2 mt-1">
              <button
                onClick={() => {
                  createGeofence();
                }}
                className="btn btn-primary p-2"
                style={{ fontSize: "11px", marginTop: "22px" }}
              >
                Create
              </button>
            </div>
            <div className="col-sm-6" style={{fontSize:'11px'}}>
         Note:  To create a geofence, begin by clicking on the map to outline the desired area, forming a polygon shape. Connect the final point to the starting point to complete the polygon. Once you've defined the area, enter a name for your geofence and click "Create" to finalize the process.
        </div>
          </>
        )}
          
      </div>
    </>
  );
}
